import React from 'react';
import styled from '@emotion/styled';
import { themeProp, styledProp } from '@vmos2/utils';
import isFinite from 'lodash/isFinite';
import type { ModeType } from 'types';

import { ProgressBar } from '../../progressBar/ProgressBar';

type Props = {
  name: string,
  progressValue: number,
  progressColor: string,
  nutritionValue: number,
  mode: ModeType,
};

export const MacrosItem = ({ name, progressValue, progressColor, nutritionValue, mode }: Props) => {
  return (
    <MacrosContainer mode={mode}>
      <MacrosName>{name}</MacrosName>
      <ProgressBar value={progressValue} color={progressColor} schemeMode={mode} />
      {isFinite(nutritionValue) && <MacroWeight>{nutritionValue}%</MacroWeight>}
    </MacrosContainer>
  );
};

const MacrosName = styled('span')`
  width: 72px;
  padding-right: 32px;
  box-sizing: content-box;
`;

const MacroWeight = styled('span')`
  text-align: right;
  padding-left: 20px;
  min-width: 70px;
`;

const MacrosContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${themeProp('fontSize.sm')};
  color: ${styledProp('mode', {
    dark: themeProp('color.lightGrey'),
    default: themeProp('color.grey'),
  })};
`;
